export default __webpack_public_path__ + "static/media/02-lootsma.707c1db5.mp4";